var _require = require('./simplify_text_attributes'),
    labels = _require.labels,
    descriptions = _require.descriptions,
    aliases = _require.aliases;

var _require2 = require('./simplify_entity'),
    entity = _require2.simplifyEntity,
    entities = _require2.simplifyEntities;

var _require3 = require('./simplify_claims'),
    claim = _require3.simplifyClaim,
    propertyClaims = _require3.simplifyPropertyClaims,
    claims = _require3.simplifyClaims,
    qualifier = _require3.simplifyQualifier,
    propertyQualifiers = _require3.simplifyPropertyQualifiers,
    qualifiers = _require3.simplifyQualifiers;

var sitelinks = require('./simplify_sitelinks');

var sparqlResults = require('./simplify_sparql_results');

module.exports = {
  entity: entity,
  entities: entities,
  labels: labels,
  descriptions: descriptions,
  aliases: aliases,
  claim: claim,
  propertyClaims: propertyClaims,
  claims: claims,
  qualifier: qualifier,
  propertyQualifiers: propertyQualifiers,
  qualifiers: qualifiers,
  sitelinks: sitelinks,
  sparqlResults: sparqlResults
};